export default __webpack_public_path__ + "static/media/loan.c4ef10c1.svg";